import { gql } from "@apollo/client";

export const CUSTOMER_FOR_INTEGRATIONS_PAGE_FRAGMENT = gql`
  fragment CustomerForIntegrationsPage on Customer {
    id
    atssyncAccounts {
      id
      type
      apiKeySuffix
    }
  }
`;
